import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { EDeleteCasesState } from '../delete-cases-state.enum';

@Injectable()
export class DeleteCasesService {

    private _endPoints = {
        deleteCases: 'api/cases'
    };

    constructor(private _restApi: RestApi) { }

    public deleteCases(): Promise<any> {
        const url = `${this._endPoints.deleteCases}`;
        return this._restApi.delete(`${url}`).toPromise();
    }

    public startProcess(): Promise<any> {
        const url = `${this._endPoints.deleteCases}`;
        return this._restApi.delete(`${url}`).toPromise();
    }

    public getState(): Promise<any> {
        const url = `${this._endPoints.deleteCases}`;
        return this._restApi.get(`${url}/delete/status`).toPromise();
    }

}